import React from "react";
import PropTypes from "prop-types";
import style from "../../../assets/css/styles.module.scss";
import InputWrapper from "../InputWrapper";
import DepDropDown from "../DepDropDown";

const textInputStyles = `${style.nested} ${style.inputForAutoComplete}`;

const InputWithDropDown = ({
  value,
  id,
  onChange,
  inputOptions,
  placeholder,
  isValid,
  errorMsg,
  className,
  label,
  afterInputText,
  data,
  autoCompleteDisabled,
  inputDisabled,
  inputLabel,
  autoCompleteLabel,
  changeAutoComplete,
  autocompleteOptions,
  autoCompleteName,
  inputName,
  parentId,
  dropDownId
}) => {
  const { inp1, inp2 } = value;

  const changeInput = e => {
    onChange({ target: { value: { inp1, inp2: e.target.value } } });
  };

  const change = e => {
    changeAutoComplete({ target: { value: { inp1: { ...inp1, ...e.target.value }, inp2 } } });
  };

  return (
    <InputWrapper
      id={`wrapperId${id}`}
      className={`${className} ${style.stringSearchOptions}`}
      isValid={isValid}
      errorMsg={errorMsg}
      label={label}
      afterInputText={afterInputText}
    >
      <>
        <DepDropDown
          dataFilter={null}
          data={data}
          options={{ ...autocompleteOptions, disabled: autoCompleteDisabled }}
          value={inp1}
          label={autoCompleteLabel}
          onChange={change}
          onBlur={change}
          placeholder={placeholder.inp1}
          className={style.nested}
          inputClassName={style.autoCompleteSmallSize}
          name={autoCompleteName}
          parentId={parentId}
          dropDownId={dropDownId}
          id={id}
        />
        <input
          type="number"
          placeholder={placeholder.inp2}
          value={inp2}
          label={inputLabel}
          {...inputOptions}
          disabled={inputDisabled}
          onChange={changeInput}
          className={isValid === false ? `${style.inputError} ${textInputStyles}` : textInputStyles}
          name={inputName}
        />
      </>
    </InputWrapper>
  );
};

InputWithDropDown.displayName = "InputWithDropDown";

InputWithDropDown.defaultProps = {
  id: "",
  value: { inp1: { code: "", name: "" }, inp2: "" },
  inputOptions: {},
  autocompleteOptions: {},
  onChange: () => {},
  placeholder: { inp1: "", inp2: "" },
  isValid: null,
  className: "",
  errorMsg: null,
  inputName: "",
  autoCompleteName: "",
  label: null,
  afterInputText: null,
  data: [],
  autoCompleteDisabled: false,
  inputDisabled: false,
  inputLabel: "",
  autoCompleteLabel: "",
  changeAutoComplete: () => {},
  parentId: "",
  dropDownId: ""
};

const isDataValid = (allProps, data, componentName) => {
  const codeNotInData = allProps[data].some(v => v.code == null);
  if (codeNotInData) {
    return new Error(`Invalid prop ${data} passed to ${componentName}. It should have "code" property in inp1 object.`);
  }
  return null;
};

const isValueValid = (allProps, value, componentName) => {
  if (allProps[value] && allProps[value].inp1 && allProps[value].inp1.code == null) {
    return new Error(
      `Invalid prop ${value} passed to ${componentName}. It should have "code" property in inp1 object.`
    );
  }
  return null;
};

InputWithDropDown.propTypes = {
  /** Wrapper id */
  id: PropTypes.string,
  /** Change event callback */
  onChange: PropTypes.func,
  /** AutoComplete data for searching. Structure: [{inp1: {code: "", name: ""}}] */
  data: isDataValid,
  /** AutoComplete input value. Structure: {inp1: {code: "", name: ""}, inp2: ""} */
  value: isValueValid,
  /* Callback function for AutoComplete */
  changeAutoComplete: PropTypes.func,
  /** Disabled value for AutoComplete */
  autoCompleteDisabled: PropTypes.bool,
  /** Disabled value for Input */
  inputDisabled: PropTypes.bool,
  /** Label for Input */
  inputLabel: PropTypes.string,
  /** Label for AutoComplete */
  autoCompleteLabel: PropTypes.string,
  /** Add any html attributes to the Input */
  inputOptions: PropTypes.object,
  /** Add any html attributes to the Select */
  autocompleteOptions: PropTypes.object,
  /** Input placeHolder */
  placeholder: PropTypes.object,
  /** Is input valid */
  isValid: PropTypes.bool,
  /** Add className to the component */
  className: PropTypes.string,
  /** Validation error message */
  errorMsg: PropTypes.string,
  /** name for Select */
  autoCompleteName: PropTypes.string,
  /** name for Input */
  inputName: PropTypes.string,
  /** If provided, will add label before the input */
  label: PropTypes.string,
  /** Parent id for calculating DropDown position */
  parentId: PropTypes.string,
  /** DropDown id for calculating DropDown position */
  dropDownId: PropTypes.string,
  /** If provided, will add text after the input */
  afterInputText: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default InputWithDropDown;
